<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YQjuhO/tc-custom/9781426852923.jpg?1718858879402" alt="This image is the cover for the book Taming of Mei Lin, Undone!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taming of Mei Lin, Undone!
      </h1>
      <p class="bookDescription body article font2">
        <b>A beautiful swordfighter rejects her suitors one duel at a time—until she meets her match in this historical romance set in Tang Dynasty China.</b><br/><br/>Faced with a proposal from a man she despises, impetuous Mei Lin makes a daring declaration: she will only marry the man who can defeat her in a sword fight. She has bested everyone who has so far tried to teach her a lesson . . . until a handsome stranger comes to her village. In captivating swordsman Shen Leung, Mei Lin finally sees a man she <i>wants</i> to marry. A man she’s willing to surrender to in <i>every</i> way. . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeannie Lin
      </h2>
      
      <p class="authorDescription body article">Jeannie Lin grew up fascinated with stories of Western epic fantasy and Eastern martial arts adventures. When her best friend introduced her to romance novels in middle school, the stage was set. Jeannie started writing her first romance while working as a high school science teacher in South Central Los Angeles. Her first two books have received starred reviews in Publishers Weekly and Library Journal and The Dragon and the Pearl was listed among Library Journal's Best Romances of 2011.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?75a8e175